import styled from '@emotion/styled';

import { createElement } from 'react';

const StringInputComponent = ({ tag, innerRef, children, ...props }) =>
	createElement(tag, { ...props, ref: innerRef }, children);

export const Input = styled(StringInputComponent)`
	display: flex;
	background-color: var(--input-bg-color);
	color: var(--black);
	font-size: var(--paragraph3-font-size);
	width: 100%;
	height: 100%;
	max-height: ${({ rows }) => (rows ? 'unset' : '4.5rem')};
	min-height: ${({ rows }) => (rows ? 'unset' : '4.5rem')};
	padding: var(--inputPadding);
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	outline: none;

	:hover {
		background-color: var(--table-selected-color);
	}
	:focus {
		background-color: var(--table-selected-color);
		border: 1px solid var(--blue);
	}
	:disabled {
		background-color: var(--input-disabled-bg-color);
		color: var(--content-4);
		-webkit-text-fill-color: var(--content-4);
		opacity: 1;
	}
	&.error {
		border: 1px solid var(--red) !important;
		background-color: var(--red-10);

		&::placeholder {
			color: var(--red);
		}
	}

	body[dir='rtl'] & {
		max-height: ${({ rows }) => (rows ? 'unset' : '5.5rem')};
		min-height: ${({ rows }) => (rows ? 'unset' : '5.5rem')};
	}

	&::placeholder {
		color: var(--content-4);
	}
`;
